import {action, observable} from 'mobx';
import GenericFormStore from '../../../../stores/FormStore';
import appStore from '../../../../containers/app/store';
import mainStore from '../../../../containers/main/store';
import {
    getFirstName,
    getLastName,
    getUserMainInstrument,
    getVideoMeetingActive,
    getVideoMeetingUrl,
    setUserFamilyName,
    setUserInstruments,
    setUserName,
    setUserProperties
} from '../../../../utils/userUtility';
import {customEvent} from "../../../../utils/analyticsUtil";
import {actions, category, events} from "../../../../constants/enums";

class ChangeNameStore extends GenericFormStore {
    @observable changePasswordSucces = false;
    @observable form = ChangeNameStore._init();

    static _init() {
        return {
            fields: {
                firstName: {
                    value: getFirstName(),
                    error: '',
                    rule: 'required'
                },
                lastName: {
                    value: getLastName(),
                    error: '',
                    rule: 'string'
                },
                videoMeetingUrl: {
                    value: getVideoMeetingUrl(),
                    error: '',
                    rule: 'url'
                },
                videoMeetingActive: {
                    value: getVideoMeetingActive(),
                    error: '',
                    rule: 'boolean'
                },
                instrument: {
                    value: getUserMainInstrument(),
                    error: '',
                    rule: 'string'
                }
            },
            meta: {
                isValid: false,
                error: null
            },
        };
    }

    @action
    resetFields = () => {
        this.form = ChangeNameStore._init();
    };

    @action
    setChip = (chip, name) => {
        this.form.fields[name].value = chip;
        this.onChange(name, this.form.fields[name].value);
    };

    @action
    updateUserName = async () => {
        const {fields} = this.form;
        const {firstName, lastName, videoMeetingUrl, videoMeetingActive, instrument} = fields;
        mainStore.toggleProgressLoader(true);
        try {
            await setUserName(firstName.value && firstName.value.trim());
            if (lastName.value) {
                await setUserFamilyName(lastName.value && lastName.value.trim());
            }

            try {
                if (videoMeetingUrl.value && videoMeetingUrl.value.trim() !== getVideoMeetingUrl()) {
                    customEvent(events.CustomEvent, {category: category.Zoom, action: actions.InsertLink});
                }
            } catch (err) {
            }
            await setUserProperties({
                videoMeetingUrl: videoMeetingUrl.value && videoMeetingUrl.value.trim(),
                videoMeetingActive: videoMeetingActive.value
            });

            await setUserInstruments(instrument.value);
            appStore.createAlertFromMessageId('success', 'notifications.nameChangeSuccess');
            this.resetFields();
        } catch (err) {
            console.log(err);
            appStore.createAlertFromMessageId('error', 'notifications.nameChangeError');
        } finally {
            mainStore.toggleProgressLoader(false);
        }
    };
}

const changeNameStore = new ChangeNameStore();
export default changeNameStore;
